var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg771X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "124px",
    viewBox: "0 0 160 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "77@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Attitude-to-goals/1",
    transform: "translate(-107.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "goals",
    transform: "translate(107.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5285986,14.6599936 C39.2060552,15.5896392 24.3591478,22.2682261 14.3156995,30.5244794 C0.694969216,41.7214502 -7.96370103,69.1297527 10.7919227,91.2195482 C38.2953967,123.612292 134.387788,138.172175 155.634132,103.792875 C175.28035,72.0027829 126.16665,11.1774499 57.5285986,14.6599936 Z",
    id: "Path-55",
    fill: "#F1EEEC",
    transform: "translate(80.000000, 69.032767) scale(-1, 1) translate(-80.000000, -69.032767) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.500000, 0.524194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5,31.7560616 L56.2955526,55.755991 L73.094401,115.757041 L69,115.757041 C66.8638478,108.354746 64.9351114,101.671197 63.2137907,95.7063958 L18.6796176,95.7070616 L13.0474548,115.846774 L8.72361755,115.846774 L32.5001312,31.7560616 L51.5,31.7560616 Z M52.5,58.5804634 L29.0639445,58.5804634 L19.8526176,91.5140616 L62.0039725,91.5140767 C55.7514748,69.8476272 52.584034,58.871662 52.50165,58.586181 L52.5,58.5804634 Z",
    id: "Combined-Shape",
    fill: "#CAC2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5,31.231868 C51.736631,31.231868 51.9408603,31.4057741 51.9893775,31.6485844 L56.7753125,55.6083564 L73.5741609,115.609407 C73.6681417,115.945081 73.4280907,116.281235 73.094401,116.281235 L69,116.281235 C68.779627,116.281235 68.5852388,116.129974 68.5214232,115.908837 L62.8427968,96.2309936 L19.0540699,96.231868 L13.5272572,115.994257 C13.464808,116.217558 13.2694163,116.370968 13.0474548,116.370968 L8.72361755,116.370968 C8.38937038,116.370968 8.14924089,116.033765 8.24423593,115.697795 L32.0207495,31.6070826 C32.0836758,31.3845306 32.2787205,31.231868 32.5001312,31.231868 L51.5,31.231868 Z M51.0938888,32.2802551 L32.8734215,32.2802551 L9.39333761,115.322581 L12.6730046,115.322581 L18.1998152,95.5601918 C18.2622634,95.3368938 18.4576501,95.1834853 18.6796081,95.1834809 L63.2138958,95.1825992 C63.4342722,95.1825948 63.6286654,95.333856 63.6924821,95.5549966 L69.3711105,115.232847 L72.4265637,115.232847 L55.8061751,55.8634681 L51.0938888,32.2802551 Z M29.0639445,58.0562698 L52.5,58.0562698 C52.6928263,58.0562698 52.8657581,58.1720785 52.9487297,58.3491752 L52.9785768,58.4286672 L62.4825151,91.3621621 C62.5715512,91.6706941 62.3770623,91.9816021 62.0856724,92.0312786 L62.0039402,92.0383196 L19.8526195,92.0383196 C19.5467886,92.0383196 19.3195989,91.7559479 19.3561675,91.4503537 L19.3728193,91.3666287 L28.5841462,58.432966 C28.6387934,58.2375836 28.7952184,58.0957124 28.9821641,58.0632974 L29.0639445,58.0562698 L52.5,58.0562698 L29.0639445,58.0562698 Z M52.1288895,59.1046569 L29.4383833,59.1046569 L20.5202841,90.9899299 L61.3302853,90.9899299 L52.1288895,59.1046569 Z",
    id: "Combined-Shape",
    fill: "#CAC2BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#CAC2BB",
    cx: 41,
    cy: 44.0322581,
    rx: 40.5,
    ry: 39.3145161
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,4.19354839 C63.6354454,4.19354839 82,22.0205503 82,44.0322581 C82,66.0439658 63.6354454,83.8709677 41,83.8709677 C18.3645546,83.8709677 0,66.0439658 0,44.0322581 C0,22.0205503 18.3645546,4.19354839 41,4.19354839 Z M41,5.24193548 C18.9003807,5.24193548 1,22.6183504 1,44.0322581 C1,65.4461657 18.9003807,82.8225806 41,82.8225806 C63.0996193,82.8225806 81,65.4461657 81,44.0322581 C81,22.6183504 63.0996193,5.24193548 41,5.24193548 Z",
    id: "Oval",
    fill: "#CAC2BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 41,
    cy: 39.8387097,
    rx: 40.5,
    ry: 39.3145161
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,0 C63.6354454,0 82,17.8270019 82,39.8387097 C82,61.8504174 63.6354454,79.6774194 41,79.6774194 C18.3645546,79.6774194 0,61.8504174 0,39.8387097 C0,17.8270019 18.3645546,0 41,0 Z M41,1.0483871 C18.9003807,1.0483871 1,18.424802 1,39.8387097 C1,61.2526173 18.9003807,78.6290323 41,78.6290323 C63.0996193,78.6290323 81,61.2526173 81,39.8387097 C81,18.424802 63.0996193,1.0483871 41,1.0483871 Z",
    id: "Oval",
    fill: "#CAC2BB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 41,
    cy: 38.7903226,
    rx: 33.5,
    ry: 32.5194146
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 41,
    cy: 37.7419355,
    rx: 25.5,
    ry: 24.7535842
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 41,
    cy: 37.353644,
    rx: 18.5,
    ry: 17.9584827
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 41,
    cy: 36.5382318,
    rx: 10.5,
    ry: 10.1926523
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F88184",
    cx: 41,
    cy: 36.1887694,
    rx: 4.5,
    ry: 4.36827957
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg771X);
export default __webpack_public_path__ + "static/media/77@1x.ac20a1a8.svg";
export { ForwardRef as ReactComponent };